import React from 'react';
import { Route, RouteProps, useLocation } from 'react-router-dom';
import { loginRedirectPrivider } from '../../services/auth';
import getCookie from '../../utils/getCookies';

interface Props extends RouteProps {
  layout: React.ComponentType<any>;
  component: React.ComponentType<any>;
  // eslint-disable-next-line react/require-default-props
  isAuth?: boolean;
}

const RouteLayout = (props: Props): JSX.Element => {
  const token: string | null = getCookie('gov_access_token_sso');
  const location = useLocation();
  const { layout: Layout, component: Component, path, isAuth } = props;
  if (isAuth && !token) {
    const { pathname } = location;
    loginRedirectPrivider(pathname);
  }

  return (
    <Route
      path={path}
      render={matchProps => (
        <Layout>
          <Component {...matchProps} />
        </Layout>
      )}
    />
  );
};

export default RouteLayout;
